import SuccessModalModel from './model/success.modal.model';
import NetellerModalModel from './model/neteller-modal.model';
import SkrillModalModel from './model/skrill-modal.model';
import BankModalModel from './model/bank-modal.model';
import EVENTS from '@shared/events';
import { showModal } from '@shared/ui/modal.util';
import { BaseController } from '@shared/basecontroller.controller';

class DepositController extends BaseController {
  constructor(AppService, DepositStore, $timeout, $translate) {
    'ngInject';

    super(AppService);

    this.DepositStore = DepositStore;

    this.$timeout = $timeout;
    this.$translate = $translate;
    this.isEnabled = null;
  }

  $onInit() {
    this.modalForm = new SuccessModalModel();
    this.netellerModal = new NetellerModalModel();
    this.skrillModal = new SkrillModalModel();
    this.bankModal = new BankModalModel();

    this.detailsSubscription = this.DepositStore.getDepositDetails().subscribe((details) => {
      this.details = details;
      this.paymentOptions = this.details.paymentOptions;
      this.PaymentOptionsViewDetails = details.paymentOptionsViewDetails;
      this.onPaymentOptionsSelected(this.paymentOptions[0]);
    });

    this.removeSettingsHighlight();
    this.checkStatus();

    this.addListener(EVENTS.BET_PROCESSED, event => this.refreshCustomerProducts());
    this.addListener(EVENTS.TRANSACTION_PROCESSED, event => this.refreshCustomerProducts());
  }

  $onDestroy() {
    super.$onDestroy();
    this.detailsSubscription.unsubscribe();
  }

  onPaymentOptionsSelected(paymentOption) {
    this.selectedPaymentOption = paymentOption;

    // // highlight active tab.
    angular.forEach(this.paymentOptions, value => value.activeTab = false);
    paymentOption.activeTab = true;

    // // update view details
    this.PaymentOptionsViewDetails.updateView(paymentOption);
  }

  isEcopayz() {
    return this.selectedPaymentOption.type === 'ECOPAYZ';
  }

  isSkrill() {
    return this.selectedPaymentOption.type === 'SKRILL';
  }

  isNeteller() {
    return this.selectedPaymentOption.type === 'NETELLER';
  }
  
  isBitcoin() {
    return this.selectedPaymentOption.type === 'BITCOIN';
  }

  isBank() {
    return this.selectedPaymentOption.type === 'BANK';
  }

  onSuccessfulSubmission(form, viewDetails) {
    this.selectedPaymentOption.email = form.email;

    if (form.isSkrill) {
      let skrillAccount = viewDetails.activeDisplay.fields.email.value;
      this.skrillModal.content = this.$translate.instant('skrillContent') + skrillAccount;
      
      showModal('skrillModal');
    }

    if (form.isNeteller) {
      if (viewDetails.activeDisplay.fields.email) {
        let netellerEmail = viewDetails.activeDisplay.fields.email.value;
        this.netellerModal.content = this.$translate.instant('netellerContent') + netellerEmail;
      } else {
        let netellerMerchantId = viewDetails.activeDisplay.fields.merchantId.value;
        let netellerMerchantTransferCode = viewDetails.activeDisplay.fields.merchantTransferCode.value;
        this.netellerModal.content = this.$translate.instant('netellerTransferNote') + netellerMerchantId + this.$translate.instant('netellerTransferNote2') + netellerMerchantTransferCode;
      }
      
      showModal('netellerModal');
    }

    if (form.isBank) {
      this.bankModal.content = this.$translate.instant('verifyDeposit');

      showModal('bankModal');
    }

    // else wait for Ecopayz redirect.
  }

  refreshCustomerProducts() {
    this.broadcast('reload.customer-products');
  }

  checkStatus() {
    this.DepositStore.getStatus()
    .then((response) => {
      if (response.is_enabled) {
        this.modalForm.successMessage = 'you will see the additional funds reflected in your account.';
        this.isEnabled = true;
      }

      $('#on-success-message').text(this.$translate.instant(this.modalForm.successMessage));
    });
  }

  removeSettingsHighlight() {
    this.$timeout(() => {
      $('#settings').removeClass('subdrop');
    }, 100);
  }
}

export default DepositController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/deposit.controller.js